import { ApiResult, PaginatedResponse, request, safeRequest } from '@synergy/api';

import { Supplier } from '../models/supplier';

export class SupplierApi {
    constructor(protected baseUrl: string) {}

    public fetchRelatedSuppliers(params?: URLSearchParams): Promise<ApiResult<PaginatedResponse<Supplier>>> {
        return safeRequest(
            () => request.get(`${this.baseUrl}/accounts/related-suppliers`, { params }),
            response => response.data
        );
    }
}
